// extracted by mini-css-extract-plugin
export var labelWrapper = "_aw-0";